export default __webpack_public_path__ + "static/8-722b4fdc68926a146d1df082c71c54a7.webp";